





















































































































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { translate } from "@/utils";

import { Employee } from "~/usersmanagement.type";

import { UsersManagementModule } from "@/store/users-management.module";
import { AuthModule } from "@/store/auth.module";

@Component({
  watch: {
    value: "init",
  },
})
export default class UserFormModal extends Mixins(FormValidator) {
  formRef = "form";
  loading = false;
  emailErrorMessage: string = "";
  actionErrorMessage: string = "";
  userContracts: any[] = [];
  userRoles: string[] = [];
  availableContracts: any[] = [];

  @Prop({
    default: function() {
      return {};
    },
  })
  user: any;
  @Prop()
  value: boolean;
  @Prop({ default: false })
  edit: boolean;

  tempUser: Employee = {} as Employee;

  get roles() {
    const roles = translate(UsersManagementModule.roles);
    return roles;
  }

  adminRoleDisabled(role: any) {
    const me = AuthModule.user || ({} as IUser);

    return (
      role.role_code === "administrator" &&
      me.role_rid === role.record_id &&
      me.record_id === this.user.record_id
    );
  }

  onCancel() {
    this.close();
  }

  async onSave() {
    const emailOk = await this.checkEmail();
    if (!this.validateForm() || !emailOk) return;

    this.loading = true;

    const contracts = [];
    for (const c of this.userContracts) {
      contracts.push({
        contract_id: c.contract_rid,
        contract_number: c.contract_number,
      });
    }
    const payload = {
      ...this.tempUser,
      ...this.metaData,
      middle_name: this.tempUser.middle_name || null,
      contracts,
      user_data: {
        contracts,
        role_rids: this.userRoles,
        isEmailVerified: this.tempUser?.user_data?.isEmailVerified || false,
      },
    };

    let response: any = {};
    if (this.edit) {
      response = await UsersManagementModule.editUser(payload);
    } else {
      payload.active = true;
      response = await UsersManagementModule.addUser(payload);
    }
    this.loading = false;

    if (response && response?.statusCode === 400) {
      const message = translate(response.message);
      this.actionErrorMessage = message.name;
      return;
    }
    this.close();
    this.update();
  }

  update() {
    this.$emit("update");
  }

  async close() {
    this.resetFormValidation();
    this.$emit("input", false);
  }

  async init(opened: boolean) {
    if (opened) {
      this.tempUser = {
        ...this.user,
        user_rid: this.user.record_id,
        email: this.user.user_email,
      } as Employee;

      await UsersManagementModule.getUnassignedContracts();

      if (this.edit) {
        this.userRoles = this.user.user_roles.map((role: any) => role.role_rid);
        this.userContracts = await UsersManagementModule.getUserContracts(
          this.user.record_id,
        );
      }

      const unassignedContracts = UsersManagementModule.availableContracts;
      this.availableContracts = [...unassignedContracts, ...this.userContracts];
    }
    this.resetFormValidation();
  }

  @Watch("tempUser.email") watchEmail() {
    this.emailErrorMessage = "";
  }

  async checkEmail() {
    const email = this.tempUser.email;
    if (!email) return;
    if (email === this.user.user_email) return true;

    const available = await UsersManagementModule.emailAvailable(email);
    if (available) {
      return true;
    } else {
      this.emailErrorMessage = this.$t(
        "profile.users_management.email_unavailable",
      ) as string;
      return false;
    }
  }

  get metaData() {
    const meta: any = {};
    const me = AuthModule.user || ({} as IUser);

    meta.bin = me.bin;
    meta.org_rid = me.org_rid;

    return meta;
  }
}
